export default __webpack_public_path__ + "static/media/ps.73a7d7c1.svg";